function loadedCallback() {
  const productSection = document.querySelector(".product-section");
  if (productSection) {
    try {
      const productInstance = theme.sections._findInstance(productSection.dataset.sectionId);
      productInstance.flickity.slideshow.on("change", (index) => {
          try {
            const productThumbs = document.querySelectorAll(".product__thumbs .product__thumb-item");
            const productThumb = productThumbs[index];
            const thumbLink = productThumb.querySelector("a");
            const thumbFeaturedMediaId = Number(thumbLink.dataset.id);
            const variant = productInstance.variantsObject.find(variant => {
                const variantHasFeaturedMedia = variant && variant.featured_media && variant.featured_media.id;
                if (!variantHasFeaturedMedia) return false;
                const variantFeaturedMediaId = variant.featured_media.id;
                return variantFeaturedMediaId === thumbFeaturedMediaId;
            });
            if (variant) {
                const select = productInstance.container.querySelector("select[data-index='option1']");
                select.value = variant.option1;
                select.dispatchEvent(new Event('change'))
            }
          } catch(e) {
            console.error("Error updating variant from product image.", e)
          }
      });
    } catch(e) {
      console.error("Error accesses product section.", e)
    }
  }
}
document.addEventListener("DOMContentLoaded", loadedCallback)
